import * as yup from 'yup';
import texts from './english-only.texts.json';

declare module 'yup' {
  interface StringSchema {
    en(): StringSchema;
  }
}

export const ENGLISH_REGEX = /^[A-Za-z\s]*$/;

export const defineEnglishOnlyValidator = () => {
  yup.addMethod(yup.string, 'en', () => {
    return yup.string().matches(ENGLISH_REGEX, { message: texts.invalidError });
  });
};
